const ArrowRightSpaceSecondary = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M13.1717 11.9997L8.22168 7.04974L9.63568 5.63574L15.9997 11.9997L9.63568 18.3637L8.22168 16.9497L13.1717 11.9997Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowRightSpaceSecondary
